import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

const ProtectedRoute = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const auth = getAuth();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
            setIsLoading(false);
        });

        return () => unsubscribe();
    }, [auth]);

    if (isLoading) {
        return <div>Loading...</div>; // Loading indicator
    }

    if (!user) {
        return <Navigate to="/signin" replace />;
    }

    return React.isValidElement(children)
        ? React.cloneElement(children, { user })
        : children;
};

export default ProtectedRoute;
